import { TFunction } from "i18next";

const STATUS_KEYS: Record<string, string> = {
  synced: "enrolment.statusSynced",
  "in system (synced)": "enrolment.statusInSystemSynced",
  "not eligible (no sync)": "enrolment.statusNotEligible",
  "eligible (not synced)": "enrolment.statusEligibleNotSynced",
  "not found": "enrolment.statusNotFound",
};

const DESCRIPTION_KEYS: Record<string, string> = {
  "this customer is eligible for portal sync but has not been synced yet":
    "enrolment.descCustomerEligible",
  "this customer is already synced and active in the portal":
    "enrolment.descCustomerSynced",
  "this customer is not eligible for online portal sync(sage x3 flag is disabled)":
    "enrolment.descCustomerNotEligible",
  "this customer is not eligible for online portal sync (sage x3 flag is disabled)":
    "enrolment.descCustomerNotEligible",
  "a portal account already exists for this rep": "enrolment.descRepAccountExists",
  "no sales rep with this code exists in sage": "enrolment.descRepNotFound",
  "rep exists but has no portal account yet": "enrolment.descRepEligible",
  "a portal account already exists for this manager":
    "enrolment.descManagerAccountExists",
  "no sales manager with this code exists in sage": "enrolment.descManagerNotFound",
  "manager exists but has no portal account yet": "enrolment.descManagerEligible",
  "portal account already exists": "enrolment.descPortalAccountExists",
  "portal account created": "enrolment.descPortalAccountCreated",
};

const ROLE_KEYS: Record<string, string> = {
  primary: "enrolment.rolePrimary",
  secondary: "enrolment.roleSecondary",
};

function normalizeLookup(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/[。.]+$/g, "");
}

export function localizeEnrolmentSyncStatus(
  status: string | null | undefined,
  t: TFunction,
  emptyLabel = "—"
): string {
  const raw = String(status ?? "").trim();
  if (!raw) return emptyLabel;
  const key = STATUS_KEYS[normalizeLookup(raw)];
  return key ? t(key) : raw;
}

export function localizeEnrolmentSyncDescription(
  description: string | null | undefined,
  t: TFunction
): string {
  const raw = String(description ?? "").trim();
  if (!raw) return "";
  const key = DESCRIPTION_KEYS[normalizeLookup(raw)];
  return key ? t(key) : raw;
}

export function localizeEnrolmentRole(
  role: string | null | undefined,
  t: TFunction,
  emptyLabel = "—"
): string {
  const raw = String(role ?? "").trim();
  if (!raw) return emptyLabel;
  const key = ROLE_KEYS[normalizeLookup(raw)];
  return key ? t(key) : raw;
}

export function identityPasswordPolicyMessage(
  password: string,
  t: TFunction
): string | null {
  if (password.length < 6) return t("common.passwordMinLength");
  if (!/[A-Z]/.test(password)) return t("common.passwordNeedUpper");
  if (!/[a-z]/.test(password)) return t("common.passwordNeedLower");
  if (!/[0-9]/.test(password)) return t("common.passwordNeedDigit");
  if (!/[^A-Za-z0-9]/.test(password)) return t("common.passwordNeedSpecial");
  return null;
}
